import { defineStore } from "pinia";
import { computed, reactive } from "vue";

import type { I_Delivery_Info } from "./delivery.types";

export const useDeliveryStore = defineStore("delivery", () => {
    const deliveryInfo = reactive<I_Delivery_Info>({
        name: "",
        surname: "",
        city: "",
        street: "",
        houseNumber: "",
        apartmentNumber: "",
        phone: "",
        arrivalDate: "",
        postalCode: "",
    });

    const isCanNext = computed(() => {
        let key: keyof I_Delivery_Info;
        for (key in deliveryInfo) {
            if (Object.prototype.hasOwnProperty.call(deliveryInfo, key)) {
                if (key === "apartmentNumber") continue;
                if (deliveryInfo[key]) continue;
                return false;
            }
        }
        return true;
    });

    const restoreToDefault = () => {
        let key: keyof I_Delivery_Info;
        for (key in deliveryInfo) {
            if (Object.prototype.hasOwnProperty.call(deliveryInfo, key)) {
                deliveryInfo[key] = "";
            }
        }
    };

    return {
        deliveryInfo,
        isCanNext,

        restoreToDefault,
    };
});
